<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import Cookie from 'js-cookie'

function applyUrlTokenLogin (store) {
  const hash = window.location.hash || ''
  const query = hash.includes('?') ? hash.split('?')[1] : ''
  const m = query.match(/(?:^|&)token=([^&]*)/)
  if (!m) return
  let token = decodeURIComponent(m[1])
  if (!token.startsWith('Bearer ')) token = 'Bearer ' + token
  Cookie.set('token', token, { expires: 7 })
  store.commit('IS_LOGIN', true)
  const [path, qs] = hash.slice(1).split('?')
  const params = new URLSearchParams(qs || '')
  params.delete('token')
  const newQs = params.toString()
  window.history.replaceState(null, '', window.location.pathname + window.location.search + '#' + path + (newQs ? '?' + newQs : ''))
}

export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  created () {
// 在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('messageStore', JSON.stringify(this.$store.state))
    })
// 在页面加载时读取localStorage里的状态信息
    localStorage.getItem('messageStore') && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage.getItem('messageStore'))))
    applyUrlTokenLogin(this.$store)
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue